import styles from './stylesChartLegend.module.scss';
import { ReactComponent as CircleIcon } from './assets/LegendCircle.svg';

const ChartLegendItemCircle = ({ value, color }) => {
  return <div className={styles.chartLegendItemCircle}>
    <CircleIcon style={{ color: color }}/>
    {value}
  </div>
}

export default ChartLegendItemCircle;